export default __webpack_public_path__ + "static/eco-7e6954080972fc8dec6826545803cd4c.png";